export function PoweredRibbon() {
  return (
    <div className="powered-ribbon">
      <span>Powered By</span>
      <strong>PicShot</strong>
    </div>
  );
}
